// == Import npm
import React from "react";
import { Button, Modal, Typography } from "antd";

// == Import SCSS
import "./modalError.less";

// == Import icons
import { ReactComponent as Printer } from "assets/illustrations/print.svg";

// == Import components

import { useTranslation } from "react-i18next";

const ModalError = ({ isVisible, onRetry, onIgnore, error }) => {
  const [t] = useTranslation();

  return (
    <div>
      <Modal
        className="modalError"
        width="700px"
        open={isVisible}
        onOk={onRetry}
        onCancel={onIgnore}
        footer={
          <>
            <Button
              type="primary"
              style={{ width: "150px" }}
              size="large"
              className="modalError__modal__yes"
              onClick={onRetry}
            >
              {t("Retry")}
            </Button>
            <Button
              style={{ width: "150px" }}
              type="default"
              size="large"
              className="modalError__modal__no"
              onClick={onIgnore}
            >
              {t("Ignore")}
            </Button>
          </>
        }
      >
        <Printer />
        <div className="modalDelete__modal__text">
          <Typography.Paragraph
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              margin: "10px 0 0 20px",
              overflowWrap: "breack-word",
            }}
          >
            {t("PrinterError")}
          </Typography.Paragraph>
          <Typography.Paragraph
            style={{
              fontSize: "14px",
              margin: "10px 0 0 20px",
              overflowWrap: "breack-word",
            }}
          >
            {t(error)}
          </Typography.Paragraph>
        </div>
      </Modal>
    </div>
  );
};

export default ModalError;
